
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[orderMethod]",
      function () {
        return require("private-next-pages/[orderMethod]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[orderMethod]"])
      });
    }
  